import { render, staticRenderFns } from "./ServerDetailsPlate.vue?vue&type=template&id=fce66fec"
import script from "./ServerDetailsPlate.vue?vue&type=script&lang=js"
export * from "./ServerDetailsPlate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports